import { useEffect } from 'react';

const byHook = hookName => `[data-ssr-cleanup="${hookName}"]`;

export const removeSSRElements = selector => {
  if (typeof document === 'undefined') return 0;

  const nodes = document.querySelectorAll(selector);
  nodes.forEach(node => node.remove());
  return nodes.length;
};
/**
 * Removes SSR-rendered elements from the DOM based on a hook name.
 * @param {string} hookName - Name of the hook to identify SSR elements
 * @returns {number} - Number of elements removed
 */
export const removeSSRByHook = hookName => {
  console.log(`[SSR cleanup] removing SSR elements for hook "${hookName}"`);
  return removeSSRElements(byHook(hookName));
};

/**
 * Hook to automatically remove SSR-rendered elements on updates.
 * Used in functional components to clean up when React takes over.
 * @param {string} hookName - Name of the hook to identify SSR elements
 * @param {any} dependency - Dependency that triggers cleanup
 */
export const useSSRCleanup = (hookName, dependency) => {
  useEffect(() => {
    console.log(`[SSR cleanup] for hook "${hookName}" executed.`);
    removeSSRByHook(hookName);
  }, [hookName, dependency]);
};
